import React, { useState, useEffect, useReducer, useContext } from 'react';
import Header from './components/Header';
import FlexView from './components/FlexView';
import FlexParentPanel from './components/FlexParentPanel';
import FlexItemPanel from './components/FlexItemPanel';
import GetCode, { GetCodeModal } from './components/GetCode';
import FlexController from './components/FlexController';
import globalReducer, { initialAppState } from './globalReducer';
import getCode from './constants/getCodeFn';
import ScreenMsg from './components/ScreenMsg';
import firebaseContext from './firebase/firebaseContext';




const Main = () => {

  const firebase = useContext(firebaseContext);  

  const [isFlexHeightFixed, setFlexHeightFixed] = useState(true);
  const [isFlexItemFixed, setFlexItemFixed] = useState(false);
  const [appState, dispatch] = useReducer(globalReducer, initialAppState);
  const [ modalData, setModalData ] = useState(false);

  useEffect(() => {
    firebase.analytics.logEvent('homepage_visited');
  }, [firebase]);
  

  const handleModalData = ( x ) => { 
    
    if( x === true){
      let j = getCode(appState).replace(/,/g, '<br/>');
      setModalData(j);
    } else {
      setModalData(null);
    }
    
  }
  

  return (
    <React.Fragment>

      <GetCodeModal codeSnippet={modalData} handleModalData={handleModalData} />

      <div className="main-content">
        {/* ------------------------------- Header --------------------------------------- */}
        <Header />

        <div className="app-layout">

          {/* ------------------------------- Col 1 --------------------------------------- */}

          <div className="col-1">

            {/* --------------------------- Flex Controller ------------------------------- */}

            <FlexController
              isFlexHeightFixed={isFlexHeightFixed}
              setFlexHeightFixed={setFlexHeightFixed}
              isFlexItemFixed={isFlexItemFixed}
              setFlexItemFixed={setFlexItemFixed}
              dispatch={dispatch}
            />

            {/* --------------------------- Flex View Control ------------------------------- */}

            <FlexView 
              isFlexHeightFixed={isFlexHeightFixed} 
              isFlexItemFixed={isFlexItemFixed}
              appState={appState} 
            />

            {/* --------------------------- Flex Parent Prop Panel --------------------------- */}

            <div className="d-flex ai-c">

              <FlexParentPanel dispatch={dispatch} parentProps={appState.parentProps} />

              <GetCode handleModalData={handleModalData} />

            </div>

          </div>

          {/* ----------------------------------- Col 2 ------------------------------------- */}

          <div className="col-2">
            <div className="flex-items-holder">

              {
                appState.flexItemProps.map((i, j) =>
                  <FlexItemPanel
                    key={j}
                    itemId={j}
                    itemProps={i}
                    dispatch={dispatch}
                  />
                )
              }

            </div>
          </div>

        </div>



      </div>

      <div className="screen-msg">
        <ScreenMsg/>
      </div>
    </React.Fragment>
  );
}

export default Main;